import React, { useState, useEffect } from 'react'

import { Pane, Button, Avatar, Pill, ListIcon, ComparisonIcon, Text, ArrowRightIcon, Badge, InfoSignIcon, Tooltip } from 'evergreen-ui'
import { MaterialTable } from './MaterialTable'

import { useAPI } from '../../Api'

function List(props) {
    let MATTURL = process.env.AJAXURL + '/assets/materials/';
    let prefixArray = [];
    // key={item.Caption || item} 
    // console.log("Props.Items: ", props.items)

    let infoUrls = useAPI().resources.infoUrls;
    return (
        <Pane style={{ overflow: 'auto' }} height={300}>
            {props.items && props.items.map((item, index) => {
                // console.log("item: ", item)
                if (!prefixArray.includes(item.SubGroup)) {
                    item.SubGroup && prefixArray.push(item.SubGroup)
                    return (
                        <Pane key={index} display="flex"
                            background="tint1" padding={8} marginBottom={10} cursor="pointer" borderRadius={"10px"}
                        >
                            <Pane flex={1} style={{ display: 'Flex', alignContent: 'center', alignItems: 'center' }}
                                onClick={() => { props.onSelected && props.onSelected(item) }}><Avatar
                                    name={item.SubGroup}
                                    size={40}
                                    marginRight={16}
                                    src={MATTURL + item + '.jpg'}
                                />
                                <Text>
                                    <div>{item.SubGroup ? item.SubGroup : item}</div>
                                </Text>

                            </Pane>


                            {infoUrls && infoUrls[item] &&
                                <a href={infoUrls[item]} target="_blank" style={{ textDecoration: "none", display: "flex", justifyContent: "center", alignItems: "center", border: "1px dashed grey", borderRadius: "10px" }}><InfoSignIcon color="info" margin={8} /></a>}
                            {infoUrls && infoUrls[item.SubGroup] &&
                                <a href={infoUrls[item.SubGroup]} target="_blank" style={{ textDecoration: "none", display: "flex", justifyContent: "center", alignItems: "center", border: "1px dashed grey", borderRadius: "10px" }}><InfoSignIcon color="info" margin={8} /></a>}

                        </Pane>
                    )
                }
            })}
        </Pane>
    )
}

function Breadcrumb(props) {
    let MATTURL = process.env.AJAXURL + '/assets/materials/';

    return (<Pane paddingTop={"10px"}>
        <Button marginRight={16} onClick={() => { props.clearSelection() }}>Materials</Button>

        {props.selectedType && <>
            <ArrowRightIcon size={10} />
            <Button paddingLeft={8}
                marginRight={16}
                marginLeft={16}
                onClick={() => {
                    if (props.subGroup != props.selectedType) {
                        props.setChoice([props.selectedType]);
                    }
                }}>
                <Avatar
                    name={props.selectedType}
                    size={40}
                    src={MATTURL + props.selectedType + '.jpg'}
                    marginRight={8}
                />
                {props.selectedType}
            </Button></>}

        {props.subGroup && (props.selectedType != props.subGroup) && <><ArrowRightIcon size={10} /><Button paddingLeft={8} marginRight={16} marginLeft={16}

            onClick={() => { }}><Avatar
                name={props.subGroup}
                size={40}
                src={MATTURL + props.selectedType + '.jpg'}
                marginRight={8}
            /> {props.subGroup}</Button></>}

    </Pane>)
}


export function TypeList(props) {
    const [material, selMaterial] = React.useState(props.selMaterial);
    const [choice, setChoice] = React.useState(null);
    const [MaterialList, setMaterialList] = React.useState(null);

    // console.log("In TypeList: ", material)


    useEffect(() => {
        setChoice(material && [material.Mgroup, material.SubGroup])
        if (props.selMaterial != material)
            props.onSelectMaterial(material)
    }, [material])

    useEffect(() => {
        if (!choice) {
            setMaterialList([...new Set(props.Materials.map((item) => item.Mgroup))])
        }
        else if (choice.length <= 1) {
            setMaterialList([...props.Materials.filter((item) => item.Mgroup == choice[0])]);
            props.onSelectMaterial(null)
        }
        else {
            setMaterialList([...props.Materials.filter((item) => item.SubGroup == choice[1])]);
        }
    }, [choice, props.Materials]);

    let setMgroup = (m) => { setChoice([m]); }
    let setSubGroup = (m) => { setChoice([choice[0], m]); }
    return <>
        {MaterialList && <> <Breadcrumb marginBottom={16}
            selectedType={choice && choice[0]}
            setChoice={setChoice}
            subGroup={choice && choice[1]}
            setSubGroup={setSubGroup}
            materials={MaterialList}
            selMaterial={selMaterial}
            clearSelection={() => {
                selMaterial(null);
                setChoice(null);
            }}></Breadcrumb><br />

            {(!choice) && <List items={MaterialList} onSelected={(i) => { setMgroup(i); }} />}
            {(choice && (choice.length <= 1) && MaterialList.length > 1) && <List items={MaterialList} onSelected={(i) => { setSubGroup(i.SubGroup); }} selectedType={choice[0]} />}
            {(choice && (choice.length > 1) || MaterialList.length == 1) && <MaterialTable onSelectMaterial={selMaterial} selMaterial={material} Materials={MaterialList} />}
        </>}
    </>
}